import { defineComponent, reactive, computed, inject, set, nextTick } from 'vue';
import { useLocalizationSupport } from '../../composables/localization-support/index.js';

var _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "UiPagination",
  props: {
    locale: { type: null, required: true },
    value: { type: Number, required: true },
    totalPages: { type: Number, required: true },
    visibleResults: { type: Number, required: false, default: 7 }
  },
  emits: ["input", "pagination-back", "pagination-forward"],
  setup(__props, { emit: emits }) {
    const props = __props;
    const refs = reactive({
      buttons: {}
    });
    const isPaginationBackDisabled = computed(() => {
      return props.value <= 0;
    });
    const isPaginationNextDisabled = computed(() => {
      return props.value >= props.totalPages - 1;
    });
    const getRefKey = (page) => {
      return `button-${page}`;
    };
    const populateButtonRef = (page, element) => {
      const key = getRefKey(page);
      set(refs.buttons, key, element);
    };
    const onClickPagination = (page) => {
      emits("input", page);
    };
    const onClickPaginationButton = (page) => {
      const toPage = page - 1;
      onClickPagination(toPage);
      nextTick(() => {
        var _a;
        const key = getRefKey(page);
        (_a = refs.buttons[key]) == null ? void 0 : _a.focus();
      });
    };
    const onClickPaginationFirst = () => {
      onClickPagination(0);
    };
    const onClickPaginationBack = () => {
      const { value } = props;
      emits("pagination-back", value);
      if (value > 0) {
        onClickPagination(value - 1);
      }
    };
    const onClickPaginationForward = () => {
      const { value, totalPages } = props;
      emits("pagination-forward", value);
      if (value < totalPages - 1) {
        onClickPagination(value + 1);
      }
    };
    const onClickPaginationLast = () => {
      onClickPagination(props.totalPages - 1);
    };
    const pages = computed(() => {
      const value = props.value + 1;
      const maxLength = Math.min(props.visibleResults, props.totalPages);
      if (props.totalPages <= maxLength) {
        return range(1, props.totalPages);
      }
      const even = maxLength % 2 === 0 ? 1 : 0;
      const left = Math.floor(maxLength / 2);
      const right = props.totalPages - left + 1 + even;
      if (value > left && value < right) {
        const start = value - left + 2;
        const end = value + left - 2 - even;
        return [1, "...", ...range(start, end), "...", props.totalPages];
      } else if (value === left) {
        const end = value + left - 1 - even;
        return [...range(1, end), "...", props.totalPages];
      } else if (value === right) {
        const start = value - left + 1;
        return [1, "...", ...range(start, props.totalPages)];
      }
      return [...range(1, left), "...", ...range(right, props.totalPages)];
    });
    const range = (from, to) => {
      const values = [];
      const fromNormalized = from > 0 ? from : 1;
      for (let i = fromNormalized; i <= to; i++) {
        values.push(i);
      }
      return values;
    };
    const isActive = (page) => {
      return page === props.value + 1;
    };
    const localizationSupport = useLocalizationSupport(props, {
      translator: inject("translator"),
      numberFormatter: inject("numberFormatter")
    });
    const { translate, numberFormat } = localizationSupport;
    return { __sfc: true, props, emits, refs, isPaginationBackDisabled, isPaginationNextDisabled, getRefKey, populateButtonRef, onClickPagination, onClickPaginationButton, onClickPaginationFirst, onClickPaginationBack, onClickPaginationForward, onClickPaginationLast, pages, range, isActive, localizationSupport, translate, numberFormat };
  }
});

export { _sfc_main as default };
